import { relations, sql } from 'drizzle-orm'
import { pgEnum, pgTable, text, uniqueIndex } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getDateField,
  getIdReference,
  getMonetaryField,
} from '../common/utils'
import { companies } from './company'

export const cashAccountKindEnum = pgEnum('cash_account_kind', [
  'bank',
  'stripe',
])

// A place money sits: a bank account. Each carries its own opening balance so a
// company's cash is the sum of its accounts. Stripe is a timing model rather
// than an account (docs/cash-flow-forecast-semantics.md §5.2), so the enum's
// `stripe` value is unused.
export const cashAccounts = pgTable(
  'cash_accounts',
  {
    ...getBaseFields(),
    companyId: getIdReference(() => companies.id),
    name: text().notNull(),
    kind: cashAccountKindEnum().notNull(),
    iban: text(),
    openingBalance: getMonetaryField().notNull(),
    openingBalanceDate: getDateField().notNull(),
    ledgerAccount: text(), // Fennoa chart-of-accounts number, e.g. '1910'
    voucherSeries: text(), // Fennoa voucher series, e.g. 'BA1'
  },
  (table) => [
    ...getBaseIndexes('cash_accounts', table),
    // Two accounts on one ledger account would each import the same booked
    // balance, and the forecast would start from it twice. The series cannot
    // tell them apart: the balance is read per account number, and an empty
    // series matches every series the ledger returns.
    uniqueIndex('cash_accounts_ledger_position_unique_idx')
      .on(table.companyId, table.ledgerAccount)
      .where(sql`ledger_account IS NOT NULL AND deleted_at IS NULL`),
  ],
)

export const cashAccountsRelations = relations(cashAccounts, ({ one }) => ({
  company: one(companies, {
    fields: [cashAccounts.companyId],
    references: [companies.id],
  }),
}))
